import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const editableListV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Form List element to v2 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'editableList'>): void => {
    const editableListProps = props;

    if (editableListProps?.style?.general?.title && !editableListProps?.content?.title?.iconColor) {
      const currentColor = editableListProps.style.general.title.color1;
      editableListProps.content = {
        ...editableListProps.content,
        title: {
          ...editableListProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
